<div class="content-card fixed">
  <div class="card-toolbar">
    <div class="card-action-buttons">
      <pa-button
        icon="pi pi-chevron-left"
        variant="outlined"
        size="small"
        severity="secondary"
        (click)="close()"
      ></pa-button>
    </div>
    <div class="card-title">Демо степпера</div>
  </div>

  <div class="stepper-wrapper">
    <p-stepper [value]="activeStep" [linear]="true">
      <p-step-list>
        <p-step [value]="1">Выбор файла</p-step>
        <p-step [value]="2">Проверка</p-step>
      </p-step-list>
    </p-stepper>
  </div>

  <div class="card-container">
    <div *ngIf="activeStep === 1" class="step-content">
      Содержимое первого шага. Выберите файл или заполните форму.
    </div>
    <div *ngIf="activeStep === 2" class="step-content">
      Содержимое второго шага. Проверьте данные перед сохранением.
    </div>
  </div>

  <div class="card-footer">
    <pa-button
      *ngIf="activeStep > 1"
      label="Назад"
      icon="pi pi-arrow-left"
      severity="secondary"
      (click)="back()"
    ></pa-button>
    <pa-button
      *ngIf="activeStep < totalSteps"
      label="Далее"
      icon="pi pi-arrow-right"
      iconPos="right"
      (click)="next()"
    ></pa-button>
    <pa-button
      *ngIf="activeStep === totalSteps"
      label="Готово"
      icon="pi pi-check"
      (click)="close()"
    ></pa-button>
  </div>
</div>
